import axios from 'axios'
import {router} from '../routes'
import store from "../store";


export default {
    namespaced: true,
    state:{
        produits: [],
        openedProduit: false,
    },
    getters: {
        produits: (state) => {
            return state.produits
        }
    },
    mutations: {
        setProduits (state, produits) { state.produits = produits },
        setOpenedProduit (state, produit) { state.openedProduit = produit },
        setOpenedProduitQuantite (state, quantite) { state.openedProduit.choix_client.quantite = quantite },
        updateOpenedProduitTotal(state, produit) {
            let total = produit.price;
            // 1. SUPPLEMENTS
            [
                // On récupère tout supplément payant
                produit.choix_client.more_supplements,
                produit.choix_client.more_boissons,
                produit.choix_client.more_sauces,
                produit.choix_client.taxonomieitems,
            ].forEach(items => {
                items.forEach(item => total += item.price)
            })

            state.openedProduit.choix_client.total = total * produit.choix_client.quantite;
        }
    },
    actions: {
        async initProduits(context) {
            const produits = (await axios.get(`/api/produits`)).data.data;
            context.commit('setProduits', produits);
        },
        async setOpenedProduit(context, id) {
            // Si on arrive sur la page directement (les produits ne sont pas chargés) on les charge

            if(!context.state.produits.length) {
                await context.dispatch('initProduits');
            }

            const produit = context.state.produits.find(produit => produit.id == id);

            context.commit('setOpenedProduit', produit);
            return produit;
        },
        setOpenedProduitQuantite(context, quantite) {
            context.commit('setOpenedProduitQuantite', quantite);
            context.commit('updateOpenedProduitTotal', context.state.openedProduit)
        }
    },
};
